const LABEL =
  "⚠️ [Modo Diagnóstico: Este elemento se ocultará en la versión final del usuario]";

/**
 * Etiqueta discreta en esquina para elementos visibles solo en modo diagnóstico SAT.
 */
export default function DiagnosticUiBadge({ className = "" }) {
  return (
    <span
      className={`block text-[9px] leading-snug text-violet-800/90 font-medium mt-1.5 ${className}`}
      data-testid="sat-ui-diagnose-badge"
    >
      {LABEL}
    </span>
  );
}
